import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationFR from './locales/fr/translation.json';

// The translations
const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  }
};

// Configure i18n
const languageDetector = {
  type: 'languageDetector',
  async: true,
  detect: (cb) => {
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage) {
      return cb(savedLanguage);
    }
    
    // Default to browser language if available, otherwise fallback to English
    const browserLanguage = window.navigator.language || window.navigator.userLanguage;
    const language = browserLanguage ? browserLanguage.split('-')[0] : 'en';
    
    // Only use browser language if it's one of our supported languages
    if (['en', 'de', 'fr'].includes(language)) {
      return cb(language);
    }
    
    return cb('en');
  },
  init: () => {},
  cacheUserLanguage: (lng) => {
    localStorage.setItem('i18nextLng', lng);
  }
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b'],
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Set initial language from localStorage or default to 'en'
const savedLang = localStorage.getItem('i18nextLng') || 'en';
i18n.changeLanguage(savedLang);

// Update HTML lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
